import React from 'react';
import styles from './AdminProjectDetailQuestionnaire.module.scss';
import BaseCard from '../../../../components/cards/BaseCard/BaseCard';
import Icon from '../../../../common/components/Icon/Icon';
import ProjectQuestionnaire from '../../../types/project/ProjectQuestionnaire';
import { Skeleton } from '@tcc-online/common-components';
import AdminProjectDetailInfoItem from '../AdminProjectDetailInfoItem/AdminProjectDetailInfoItem';
import IAdminProject from '../../../types/IAdminProject';
import useDate from '../../../../hooks/useDate';
import { useTranslate } from 'react-translate.ts';
import AdminButton from '../../buttons/AdminButton/AdminButton';
import { generatePath, Link } from 'react-router-dom';
import {
    ADMIN_PROJECT_EDIT_PATH,
    ADMIN_PROJECT_QUESTIONNAIRES_DETAIL_PATH,
    ADMIN_PROJECT_QUESTIONNAIRES_PATH,
} from '../../../../constants/route.constants';

interface AdminProjectDetailQuestionnaireProps {
    questionnaire: ProjectQuestionnaire;
    project: IAdminProject;
    loading: boolean;
}

const iconSkeleton = <Skeleton className={styles.icon} />;
const listSkeleton = Array.from(new Array(5), (_, index: number) => (
    <Skeleton key={index} className={styles.skeleton} />
));
const nameSkeleton = <Skeleton height={30} width={150} />;

export default function AdminProjectDetailQuestionnaire(
    props: AdminProjectDetailQuestionnaireProps,
) {
    const { questionnaire, loading, project } = props;
    const createdAt = useDate(project?.createdDate, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    });
    const translate = useTranslate();

    return (
        <BaseCard className={styles.card}>
            {!loading ? (
                <Icon
                    name={questionnaire?.internalName}
                    className={styles.icon}
                />
            ) : (
                iconSkeleton
            )}
            <div className={styles.content}>
                {!loading ? (
                    <div className={styles.name}>{questionnaire?.name}</div>
                ) : (
                    nameSkeleton
                )}
                <div className={styles.list}>
                    {!loading ? (
                        <>
                            <AdminProjectDetailInfoItem
                                label={translate('Založeno:')}
                            >
                                {createdAt}
                            </AdminProjectDetailInfoItem>
                            <AdminProjectDetailInfoItem
                                label={translate('Komparativní:')}
                            >
                                {translate(project?.comparative ? 'ano' : 'ne')}
                            </AdminProjectDetailInfoItem>
                            <AdminProjectDetailInfoItem
                                label={translate('Time to fill:')}
                            >
                                {questionnaire?.timeToFill}
                            </AdminProjectDetailInfoItem>
                        </>
                    ) : (
                        listSkeleton
                    )}
                </div>
                <div className={styles.buttons}>
                    <Link
                        to={generatePath(ADMIN_PROJECT_EDIT_PATH, {
                            '*': ADMIN_PROJECT_QUESTIONNAIRES_PATH,
                        })}
                    >
                        <AdminButton embossed>
                            {translate('Nastavení dotazniku')}
                        </AdminButton>
                    </Link>
                    {questionnaire?.id !== null &&
                        questionnaire?.id !== undefined && (
                            <Link
                                to={generatePath(
                                    `../${ADMIN_PROJECT_QUESTIONNAIRES_PATH}/${ADMIN_PROJECT_QUESTIONNAIRES_DETAIL_PATH}`,
                                    {
                                        questionnaireId:
                                            questionnaire.id.toString(),
                                    },
                                )}
                            >
                                <AdminButton embossed>
                                    {translate('Detail')}
                                </AdminButton>
                            </Link>
                        )}
                </div>
            </div>
        </BaseCard>
    );
}
